import { render } from "./LogView.vue?vue&type=template&id=f2df6a5c&scoped=true"
import script from "./LogView.vue?vue&type=script&lang=js"
export * from "./LogView.vue?vue&type=script&lang=js"

import "./LogView.vue?vue&type=style&index=0&id=f2df6a5c&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2df6a5c"]])

export default __exports__